/*
 * "Daha fazlasını gör": Kombinini tamamla bölümünün sonunda bir düğme; ürün sayfasından çıkmadan
 * alttan açılan tam ekran keşif penceresi. Reklamdan gelip tek ürün sayfasında kalan müşteriyi
 * mağazanın içine alır.
 *  - Kaynak: ürünün dünyasının (hardstone.discovery_partition) otomatik koleksiyonları ve "Tüm mağaza"
 *    (/collections/<handle>/products.json). Yalnızca satışta olan, görseli olan ürünler; bu ürün hariç.
 *  - Ürün tipine göre filtre; bir karta dokunmak o ürüne gider.
 *  - Telefonun geri tuşu pencereyi kapatır (history), Esc de kapatır.
 *  - Ölçüm: hs_more_view, hs_more_open, hs_more_click.
 */
(function () {
  if (window.__hsMore) return;
  window.__hsMore = true;

  var cfg = document.querySelector('[data-hs-more]');
  if (!cfg) return;
  var HANDLE = cfg.dataset.handle || '';
  var WORLDS = {
    reed: { label: 'Sazlık', cols: ['hs2-auto-reed'] },
    forest: { label: 'Orman', cols: ['hs2-auto-forest', 'hs2-auto-forest-first-layer'] },
    neon: { label: 'Neon', cols: ['hs2-auto-neon'] },
    neutral: { label: 'Sade tonlar', cols: ['hs2-auto-neutral'] }
  };
  var world = WORLDS[cfg.dataset.partition] || null;
  var CATS = [['all', 'Tümü'], ['tee', 'Tişört'], ['mid', 'Polar · Sweat'], ['outer', 'Mont · Kaban'], ['vest', 'Yelek · Gömlek'], ['bottom', 'Pantolon'], ['set', 'Takım · Set'], ['acc', 'Aksesuar']];
  var money = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name, data) {
    if (window.hs3Track) return window.hs3Track(name, data || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function kind(title) {
    var t = title.toLocaleLowerCase('tr-TR');
    var has = function () { for (var i = 0; i < arguments.length; i++) if (t.indexOf(arguments[i]) > -1) return true; return false; };
    if (has('takım', 'seti', 'kombini')) return 'set';
    if (has('pantolon', 'tulum', 'eşofman')) return 'bottom';
    if (has('şapka', 'bere', 'çanta', 'palaska', 'çizme')) return 'acc';
    if (has('kaban', 'mont', 'ceket', 'parka')) return 'outer';
    if (has('polar', 'sweat', 'hırka')) return 'mid';
    if (has('yele', 'gömle')) return 'vest';
    if (has('tişört', 't-shirt', 'tshirt')) return 'tee';
    return 'acc';
  }

  // ---------- data ----------
  var cache = {};
  function load(key) {
    if (cache[key]) return cache[key];
    var urls = key === 'all' || !world
      ? ['/collections/all/products.json?limit=250']
      : world.cols.map(function (c) { return '/collections/' + c + '/products.json?limit=250'; });
    cache[key] = Promise.all(urls.map(function (u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
    })).then(function (rs) {
      var seen = {}, out = [];
      rs.forEach(function (r) {
        (r.products || []).forEach(function (p) {
          if (!p || seen[p.handle] || p.handle === HANDLE || /-(meta|reklam)$/.test(p.handle)) return;
          seen[p.handle] = 1;
          var tags = [].concat(p.tags || []).join(',');
          if (tags.indexOf('Meta Catalog Proxy') > -1) return;
          var live = (p.variants || []).filter(function (v) { return v.available; });
          var img = p.images && p.images[0] && p.images[0].src;
          if (!live.length || !img) return;
          out.push({
            handle: p.handle, title: p.title, img: img,
            price: Math.min.apply(null, live.map(function (v) { return parseFloat(v.price) || 0; })),
            cat: kind(p.title + ' ' + (p.product_type || ''))
          });
        });
      });
      return out;
    });
    return cache[key];
  }

  // ---------- styles ----------
  var css = [
    '.hs-more-cta{margin:28px 0 8px;padding:0 var(--hs-more-gutter,16px)}',
    '.hs-more-cta__btn{width:100%;display:grid;grid-template-columns:auto minmax(0,1fr) 40px;gap:14px;align-items:center;padding:14px 14px 14px 16px;border:0;border-radius:18px;background:#1d2a20;color:#f3efe4;text-align:left;cursor:pointer;-webkit-tap-highlight-color:transparent;box-shadow:0 18px 34px -22px rgba(0,0,0,.75);transition:transform .18s cubic-bezier(.2,.8,.2,1)}',
    '.hs-more-cta__btn:active{transform:scale(.985)}',
    '.hs-more-cta__btn:focus-visible{outline:2px solid #d9b26a;outline-offset:3px}',
    '.hs-more-cta__stack{display:flex}',
    '.hs-more-cta__stack img{width:40px;height:50px;object-fit:contain;padding:3px;box-sizing:border-box;margin-left:-12px;border-radius:9px;background:#ebe6d9;box-shadow:0 0 0 2px #1d2a20}',
    '.hs-more-cta__stack img:first-child{margin-left:0}',
    '.hs-more-cta__txt{display:grid;gap:2px;min-width:0}',
    '.hs-more-cta .hs-more-cta__btn .hs-more-cta__txt strong{font:400 19px/1.15 var(--hs3-serif,"Newsreader",Georgia,serif);letter-spacing:-.01em;color:#f3efe4!important}',
    '.hs-more-cta .hs-more-cta__btn .hs-more-cta__txt small{font:500 12px/1.3 var(--font-body-family);color:rgba(243,239,228,.72)!important}',
    '.hs-more-cta__go{display:grid;place-items:center;width:40px;height:40px;border-radius:50%;background:#d9b26a;color:#1d2a20}',
    '@media (prefers-reduced-motion:no-preference){.hs-more-cta.is-pending{opacity:0;transform:translateY(16px)}.hs-more-cta.is-in{animation:hs-more-rise .7s cubic-bezier(.2,.8,.2,1) both}.hs-more-cta.is-in .hs-more-cta__go svg{animation:hs-more-nudge 1.6s .8s ease-in-out 2}}',
    '@keyframes hs-more-rise{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}',
    '@keyframes hs-more-nudge{0%,100%{transform:none}50%{transform:translateX(3px)}}',
    'html.hs-more-open,html.hs-more-open body{overflow:hidden!important}',
    '.hs-more{position:fixed;inset:0;z-index:2147483000;display:block}',
    '.hs-more[hidden]{display:none!important}',
    '.hs-more__scrim{position:absolute;inset:0;background:rgba(17,24,19,.55);opacity:0;transition:opacity .32s ease}',
    '.hs-more.is-open .hs-more__scrim{opacity:1}',
    '.hs-more__sheet{position:absolute;left:0;right:0;bottom:0;height:calc(100% - 40px - env(safe-area-inset-top,0px));display:flex;flex-direction:column;background:#f3f0e8;color:#1f2b20;border-radius:22px 22px 0 0;box-shadow:0 -20px 50px -20px rgba(0,0,0,.45);transform:translateY(100%);transition:transform .46s cubic-bezier(.2,.85,.2,1);will-change:transform}',
    '.hs-more.is-open .hs-more__sheet{transform:none}',
    '@media (min-width:750px){.hs-more__sheet{left:50%;right:auto;width:560px;margin-left:-280px}}',
    '.hs-more__top{padding:8px max(16px,env(safe-area-inset-left,0px)) 10px max(16px,env(safe-area-inset-right,0px));border-bottom:1px solid rgba(52,73,54,.12)}',
    '.hs-more__grab{display:block;width:40px;height:4px;margin:0 auto 10px;border-radius:2px;background:#cfc8b5}',
    '.hs-more__bar{display:grid;grid-template-columns:minmax(0,1fr) 44px;align-items:center;gap:12px}',
    '.hs-more__eyebrow{margin:0;font:600 10px/1.3 var(--hs3-mono,ui-monospace,monospace);letter-spacing:.14em;text-transform:uppercase;color:#8a6424}',
    '.hs-more__title{margin:2px 0 0;font:400 26px/1.1 var(--hs3-serif,"Newsreader",Georgia,serif);letter-spacing:-.015em;color:#1f2b20}',
    '.hs-more__close{width:44px;height:44px;border:0;border-radius:50%;background:#e7e2d4;color:#1f2b20;display:grid;place-items:center;cursor:pointer}',
    '.hs-more__tabs{display:flex;gap:4px;margin-top:12px;padding:3px;border-radius:999px;background:#e7e2d4}',
    '.hs-more__tab{flex:1;min-height:38px;border:0;border-radius:999px;background:transparent;font:600 13px/1 var(--font-body-family);color:#4b5446;cursor:pointer;transition:background .2s ease,color .2s ease,box-shadow .2s ease}',
    '.hs-more__tab[aria-selected=true]{background:#f9f7f1;color:#1f2b20;box-shadow:0 2px 8px -4px rgba(31,42,34,.35)}',
    '.hs-more__chips{display:flex;gap:8px;margin:12px calc(-1 * max(16px,env(safe-area-inset-left,0px))) 0;padding:0 max(16px,env(safe-area-inset-left,0px));overflow-x:auto;scrollbar-width:none}',
    '.hs-more__chips::-webkit-scrollbar{display:none}',
    '.hs-more__chip{flex:none;min-height:36px;padding:0 14px;border:1px solid rgba(52,73,54,.22);border-radius:999px;background:transparent;font:500 13px/1 var(--font-body-family);color:#2f3d2f;cursor:pointer;white-space:nowrap;transition:background .2s ease,color .2s ease,border-color .2s ease}',
    '.hs-more__chip span{margin-left:6px;color:#8b8f86;font-size:11.5px}',
    '.hs-more__chip[aria-pressed=true]{background:#2f4a31;border-color:#2f4a31;color:#f3efe4}',
    '.hs-more__chip[aria-pressed=true] span{color:rgba(243,239,228,.7)}',
    '.hs-more__scroll{flex:1;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:14px max(16px,env(safe-area-inset-left,0px)) calc(24px + env(safe-area-inset-bottom,0px)) max(16px,env(safe-area-inset-right,0px))}',
    '.hs-more__count{margin:0 0 12px;font:400 12.5px/1.3 var(--font-body-family);color:#6a7062}',
    '.hs-more__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;transition:opacity .16s ease}',
    '.hs-more__grid.is-swap{opacity:0}',
    '.hs-more__card{display:grid;grid-template-rows:auto auto;border-radius:14px;overflow:hidden;background:#f9f7f1;color:#1f2b20;text-decoration:none;box-shadow:0 0 0 1px rgba(52,73,54,.08);-webkit-tap-highlight-color:transparent;transition:transform .18s cubic-bezier(.2,.8,.2,1)}',
    '.hs-more__card:active{transform:scale(.975)}',
    '.hs-more__media{display:block;aspect-ratio:4/5;background:#ebe6d9}',
    '.hs-more__media img{width:100%;height:100%;object-fit:contain;padding:10px;box-sizing:border-box;display:block}',
    '.hs-more__body{display:grid;gap:4px;padding:10px 11px 12px}',
    '.hs-more__name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.6em;font:500 12.5px/1.3 var(--font-body-family)}',
    '.hs-more__price{font:400 16px/1.1 var(--hs3-serif,"Newsreader",Georgia,serif)}',
    '.hs-more__empty{grid-column:1/-1;padding:40px 0;text-align:center;font:400 14px/1.5 var(--font-body-family);color:#6a7062}',
    '.hs-more__skel{aspect-ratio:4/6;border-radius:14px;background:linear-gradient(100deg,#ebe6d9 30%,#f3efe5 50%,#ebe6d9 70%);background-size:300% 100%;animation:hs-more-skel 1.2s ease-in-out infinite}',
    '@keyframes hs-more-skel{from{background-position:100% 0}to{background-position:0 0}}',
    '@media (prefers-reduced-motion:no-preference){.hs-more__card.is-new{animation:hs-more-card .55s cubic-bezier(.2,.8,.2,1) both;animation-delay:calc(var(--i,0) * 40ms)}}',
    '@keyframes hs-more-card{from{opacity:0;transform:translateY(14px) scale(.98)}to{opacity:1;transform:none}}',
    '@media (prefers-reduced-motion:reduce){.hs-more__sheet,.hs-more__scrim,.hs-more__grid{transition:none!important}}'
  ].join('\n');
  var style = el('style'); style.textContent = css; document.head.appendChild(style);

  var ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  // ---------- the button under "Kombinini tamamla" ----------
  var cta;
  function placeCta() {
    if (cta) return;
    var disc = document.getElementById('hs2-discovery');
    var anchor = disc && disc.querySelector('.hs2__stream') ? disc : null;
    if (!anchor) return false;
    cta = el('div', 'hs-more-cta' + (still ? '' : ' is-pending'));
    var btn = el('button', 'hs-more-cta__btn');
    btn.type = 'button';
    var stack = el('span', 'hs-more-cta__stack'); stack.setAttribute('aria-hidden', 'true');
    var txt = el('span', 'hs-more-cta__txt');
    txt.appendChild(el('strong', '', 'Daha fazlasını gör'));
    var sub = el('small', '', world ? world.label + ' seçkisi ve tüm mağaza' : 'Tüm mağazayı burada gezin');
    txt.appendChild(sub);
    var go = el('span', 'hs-more-cta__go'); go.setAttribute('aria-hidden', 'true'); go.innerHTML = ARROW;
    btn.appendChild(stack); btn.appendChild(txt); btn.appendChild(go);
    btn.addEventListener('click', function () { open(); });
    cta.appendChild(btn);
    anchor.appendChild(cta);

    var warm = function () {
      load(world ? 'world' : 'all').then(function (items) {
        if (!items.length) return;
        sub.textContent = (world ? world.label + ' seçkisinde ' : 'Mağazada ') + items.length + ' ürün daha';
        items.slice(0, 3).forEach(function (it) { var i = el('img'); i.alt = ''; i.loading = 'lazy'; i.src = sized(it.img, 120); stack.appendChild(i); });
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting && x.intersectionRatio > 0) {
            if (x.rootBounds && x.boundingClientRect.top < x.rootBounds.bottom) { cta.classList.remove('is-pending'); cta.classList.add('is-in'); track('hs_more_view', {}); io.disconnect(); }
            warm();
          }
        });
      }, { rootMargin: '0px 0px 600px 0px', threshold: [0, 0.3] });
      io.observe(cta);
    } else { cta.classList.remove('is-pending'); warm(); }
    return true;
  }

  // ---------- the sheet ----------
  var root, grid, chipsBox, count, tabs, state = { tab: world ? 'world' : 'all', cat: 'all' }, pushed = false, lastFocus;
  function build() {
    root = el('div', 'hs-more'); root.hidden = true;
    var scrim = el('div', 'hs-more__scrim'); scrim.addEventListener('click', function () { close(true); });
    var sheet = el('div', 'hs-more__sheet');
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-labelledby', 'hs-more-title');
    var top = el('div', 'hs-more__top');
    top.appendChild(el('span', 'hs-more__grab'));
    var bar = el('div', 'hs-more__bar');
    var heads = el('div');
    heads.appendChild(el('p', 'hs-more__eyebrow', 'Keşfet'));
    var h = el('h2', 'hs-more__title', world ? world.label + ' seçkisi' : 'Tüm mağaza'); h.id = 'hs-more-title';
    heads.appendChild(h);
    var x = el('button', 'hs-more__close'); x.type = 'button'; x.setAttribute('aria-label', 'Kapat'); x.innerHTML = CLOSE;
    x.addEventListener('click', function () { close(true); });
    bar.appendChild(heads); bar.appendChild(x); top.appendChild(bar);
    tabs = el('div', 'hs-more__tabs'); tabs.setAttribute('role', 'tablist');
    [['world', world ? world.label : ''], ['all', 'Tüm mağaza']].forEach(function (t) {
      if (t[0] === 'world' && !world) return;
      var b = el('button', 'hs-more__tab', t[1]); b.type = 'button'; b.setAttribute('role', 'tab'); b.dataset.tab = t[0];
      b.addEventListener('click', function () { if (state.tab === t[0]) return; state.tab = t[0]; state.cat = 'all'; h.textContent = t[0] === 'world' ? world.label + ' seçkisi' : 'Tüm mağaza'; render(true); });
      tabs.appendChild(b);
    });
    if (tabs.children.length > 1) top.appendChild(tabs);
    chipsBox = el('div', 'hs-more__chips'); top.appendChild(chipsBox);
    var scroll = el('div', 'hs-more__scroll');
    count = el('p', 'hs-more__count');
    grid = el('div', 'hs-more__grid');
    scroll.appendChild(count); scroll.appendChild(grid);
    sheet.appendChild(top); sheet.appendChild(scroll);
    root.appendChild(scrim); root.appendChild(sheet);
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
    grid.addEventListener('click', function (e) { var a = e.target.closest('a'); if (a) track('hs_more_click', { handle: a.dataset.handle || '', tab: state.tab, cat: state.cat }); });
    document.body.appendChild(root);
    root._scroll = scroll;
  }

  function render(swap) {
    [].forEach.call(tabs.children, function (b) { b.setAttribute('aria-selected', String(b.dataset.tab === state.tab)); });
    if (!grid.children.length || swap) {
      grid.innerHTML = '';
      for (var s = 0; s < 6; s++) grid.appendChild(el('div', 'hs-more__skel'));
    }
    load(state.tab).then(function (items) {
      var counts = {}; items.forEach(function (it) { counts[it.cat] = (counts[it.cat] || 0) + 1; });
      chipsBox.innerHTML = '';
      CATS.forEach(function (c) {
        var n = c[0] === 'all' ? items.length : (counts[c[0]] || 0);
        if (!n) return;
        var b = el('button', 'hs-more__chip', c[1]); b.type = 'button';
        b.appendChild(el('span', '', String(n)));
        b.setAttribute('aria-pressed', String(state.cat === c[0]));
        b.addEventListener('click', function () { if (state.cat === c[0]) return; state.cat = c[0]; render(true); });
        chipsBox.appendChild(b);
      });
      var list = state.cat === 'all' ? items : items.filter(function (it) { return it.cat === state.cat; });
      var paint = function () {
        grid.innerHTML = '';
        count.textContent = list.length ? list.length + ' ürün · dokunun, ürüne gidin' : '';
        if (!list.length) { grid.appendChild(el('p', 'hs-more__empty', 'Bu filtrede şu an satışta ürün yok.')); return; }
        list.forEach(function (it, i) {
          var a = el('a', 'hs-more__card' + (i < 14 ? ' is-new' : ''));
          a.href = '/products/' + it.handle; a.dataset.handle = it.handle;
          a.style.setProperty('--i', String(i));
          var m = el('span', 'hs-more__media'); var img = el('img'); img.alt = it.title; img.loading = i < 6 ? 'eager' : 'lazy'; img.decoding = 'async'; img.src = sized(it.img, 360); m.appendChild(img);
          var b = el('span', 'hs-more__body');
          b.appendChild(el('span', 'hs-more__name', it.title));
          b.appendChild(el('span', 'hs-more__price', money.format(it.price) + ' TL'));
          a.appendChild(m); a.appendChild(b); grid.appendChild(a);
        });
        root._scroll.scrollTop = 0;
        grid.classList.remove('is-swap');
      };
      if (swap && !still) { grid.classList.add('is-swap'); setTimeout(paint, 140); } else paint();
    });
  }

  function open() {
    if (!root) build();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('hs-more-open');
    render(false);
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    try { history.pushState({ hsMore: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    var x = root.querySelector('.hs-more__close'); if (x) x.focus({ preventScroll: true });
    track('hs_more_open', { tab: state.tab });
  }
  function close(fromUi) {
    if (!root || root.hidden) return;
    if (fromUi && pushed) { pushed = false; history.back(); return; }
    pushed = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('hs-more-open');
    setTimeout(function () { root.hidden = true; }, still ? 0 : 460);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.addEventListener('popstate', function () { if (root && !root.hidden) { pushed = false; close(false); } });

  // Wait for the discovery section to draw, then place the button.
  if (!placeCta()) {
    var mo = new MutationObserver(function () { if (placeCta()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
})();
